import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  IconButton,
} from '@mui/material';
import {
  Add as AddIcon,
  ChatBubbleOutline as ChatBubbleOutlineIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import styles from 'pages/main/WizardPage/WizardPage.module.css';
import default_theme from 'assets/themes/themes';

const ChatHistory = ({ 
  savedChats, 
  currentChatId, 
  onStartNewChat, 
  onLoadChat, 
  onDeleteChat 
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        width: { xs: 0, md: 280 },
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        borderRadius: 0,
        height: '100%',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          p: 2,
          backgroundColor: default_theme.palette.other.backgroundGrey,
          borderBottom: `1px solid ${default_theme.palette.border.subtle}`,
          flexShrink: 0,
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onStartNewChat}
          fullWidth
          sx={{ mb: 2, bgcolor: default_theme.palette.other.chatGreen, '&:hover': { bgcolor: default_theme.palette.other.chatGreenHover } }}
        >
          New Chat
        </Button>
        <Typography variant="h6" sx={{ fontWeight: 600, color: default_theme.palette.primary.gray }}>
          Chat History
        </Typography>
      </Box>
      
      <Box 
        sx={{ 
          flex: 1, 
          overflowY: 'auto',
          minHeight: 0,
        }} 
        className={styles.scrollbar}
      >
        <List dense sx={{ p: 0 }}>
          {savedChats.map((chat) => (
              <ListItem
                key={chat.id}
                button
                onClick={() => onLoadChat(chat.id)}
                selected={currentChatId === chat.id}
                className={styles.chatHistoryItem}
                sx={{
                  borderBottom: `1px solid ${default_theme.palette.border.subtleLighter}`,
                  '&.Mui-selected': {
                    backgroundColor: default_theme.palette.other.paleGreen,
                    '&:hover': { backgroundColor: default_theme.palette.other.chatGreen },
                  },
                }}
              >
              <ListItemIcon>
                <ChatBubbleOutlineIcon color="action" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" sx={{ fontWeight: 500 }}>{chat.title}</Typography>}
              />
              <IconButton 
                size="small" 
                onClick={(e) => onDeleteChat(chat.id, e)} 
                sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
};

export default ChatHistory;